export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="w-full px-6 md:px-12 pt-16 pb-10 border-t border-white/10 bg-[#0A111D]"
  >
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
      <div className="md:col-span-5">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-3 h-3 bg-accent block" />
          <span className="font-display text-2xl tracking-tight">GND SOLUTION</span>
        </div>
        <p className="text-[#94A3B8] font-light leading-relaxed max-w-sm">
          Offshore crane operations, rigging and heavy-lift crews for the energy,
          marine and construction sectors.
        </p>
      </div>

      <div className="md:col-span-3 md:col-start-7">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#64748B] block mb-5">Services</span>
        <ul className="space-y-3 text-[#94A3B8]">
          <li>Crane Operation</li>
          <li>Heavy & Tandem Lifts</li>
          <li>Rigging & Slinging</li>
          <li>Inspection & Maintenance</li>
        </ul>
      </div>

      <div className="md:col-span-3">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#64748B] block mb-5">Contact</span>
        <ul className="space-y-3 text-[#94A3B8]">
          <li><a href="mailto:ops@gndsolution.co" className="hover:text-accent transition-colors">ops@gndsolution.co</a></li>
          <li><a href="tel:+4401224000000" className="hover:text-accent transition-colors">+44 (0) 1224 000 000</a></li>
          <li>Aberdeen · Rotterdam · Takoradi</li>
        </ul>
      </div>
    </div>

    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/10">
      <span className="font-mono text-xs tracking-[0.15em] uppercase text-[#64748B]">
        © {new Date().getFullYear()} GND Solution Offshore Lifting Ltd.
      </span>
      <span className="font-mono text-xs tracking-[0.15em] uppercase text-[#64748B]">
        LOLER · OPITO · ISO 45001
      </span>
    </div>
  </footer>
);
